import {useContext, useEffect, useState} from 'react';
import {AppCtx} from '../../../AppCtx';
import yjsDocumentService from '../../../infrastructure/sync/YjsDocumentService';
import {getWorkspaceIdForSession} from '../../../shared/services/dbUtils';
import {LineProcessor} from '../../song/services/line-processor';
import {JsonToSong} from '../../song/services/json-to-song';
import {isSongbook} from './dashboardData';

// Read one workspace snapshot after local persistence or remote Yjs updates.
export const useSongbookLibrary = (countSongs = false) => {
  const {currentSessionId} = useContext(AppCtx);
  const workspaceId = getWorkspaceIdForSession(currentSessionId);
  const [files, setFiles] = useState([]);
  const [songsCount, setSongsCount] = useState(null);
  const [modifiedTimes, setModifiedTimes] = useState({});

  useEffect(() => {
    const {doc} = yjsDocumentService.connectToDocument(workspaceId);
    let timer;
    const refresh = () => {
      const paths = Array.from(doc.getMap('files').keys()).filter(isSongbook);
      setFiles(paths);
      setModifiedTimes(Object.fromEntries(paths.map(path => [path, doc.getMap(`metadata:${path}`).get('lastEditTime')])));
      if (countSongs) {
        const processor = new LineProcessor();
        const converter = new JsonToSong();
        const total = paths.reduce((count, path) => {
          const content = doc.getText('content:' + path).toString();
          return count + converter.songsEnriched(processor.parseChordsTxt(content)).length;
        }, 0);
        setSongsCount(total);
      }
    };
    const scheduleRefresh = () => {
      clearTimeout(timer);
      timer = setTimeout(refresh, 100);
    };
    doc.on('update', scheduleRefresh);
    refresh();
    return () => {
      clearTimeout(timer);
      doc.off('update', scheduleRefresh);
    };
  }, [workspaceId, countSongs]);

  return {files, songsCount, modifiedTimes};
};
